import _ from 'underscore';
import Backbone from 'backbone';
import Global from 'models/Global';
import AddToCalendarView from 'web-common/scripts/views/AddToCalendarView';
import template from 'hbars!templates/sessionPageView';
import { fetchMarkerData } from './Utils';

var SessionPageView = Backbone.View.extend({

    events: {
        'click .session-back-btn': 'backButtonClicked',
        'click .session-like-btn': 'likeSession',
        'click .dropdown-add-session': 'addSessionClicked',
        'click .dropdown-remove-session': 'removeSessionClicked'
    },

    initialize: function(options) {
        this.event = options.event || {};
        this.agenda = Global.get('agenda');
        this.me = Global.get('me');
        this.addToCalendarView = new AddToCalendarView({event: this.event, session: this.model});

        fetchMarkerData('like', 'sessions', this);
        fetchMarkerData('addToCal', 'sessions', this);
        fetchMarkerData('likeCount', 'sessions', this, 'likesCount');

        this.listenTo(this.model, 'sessionLike', this.renderLikeButton);
        this.listenTo(this.model, 'sessionFavorite', this.render);
    },
    redirectToCommunity: function() {
        var url = this.event.getCommunityUrl();
        if (this.agenda.get('isWidget')) {
            var win = window.open(url, '_blank');
            win.focus();
        } else {
            window.location = url;
        }
    },

    backButtonClicked: function() {
        window.history.back();
    },

    addSessionClicked: function() {
        if (!this.me.get('isJoined')) {
            this.redirectToCommunity();
            return;
        }
        this.model.addToCalendar({shouldAdd: true});
    },

    removeSessionClicked: function() {
        this.model.addToCalendar({shouldAdd: false});
    },

    likeSession: function() {
        if (!this.me.get('isJoined')) {
            this.redirectToCommunity();
            return;
        }
        var thisView = this;
        if (this.model.get('markersData').like) {
            this.model.like({shouldLike: false});
        } else {
            this.$('.icon-like').toggleClass('animated', true);
            _.delay(function(){
                thisView.$('.icon-like').toggleClass('animated', false);
                thisView.model.like({shouldLike: true});
            }, 2100);
        }
    },

    renderLikeButton: function() {
        var likesNumber = (this.model.get('markersData').likeCount === 0) ? '' : this.model.get('markersData').likeCount;
        this.$('.like-number').text(likesNumber);
        this.$('.icon-like').toggleClass('liked', this.model.get('markersData').like);
    },

    remove: function() {
        this.addToCalendarView.remove();
        return Backbone.View.prototype.remove.call(this);
    },

    renderAddToCalendar: function() {
        this.addToCalendarView.setElement(this.$('.add-to-calendar')).render();
        this.renderTooltip();
    },

    renderTooltip: function() {
        this.$('.track-circle').tooltip({});
        if (!this.me.get('isJoined')) {
            this.$('.joined-only-tooltip').tooltip({});
        }
    },

    render: function() {
        const isVisible = this.model.get('tracks').findWhere({disabled: false});
        const session = this.model.toJSON();
        const html = template({
            session: session,
            event: this.event.toJSON(),
            sessionUrl: this.event.getAgendaSessionUrl(session.id),
            isWidget: Global.get('isWidget'),
            isJoined: Global.get('me') && Global.get('me').get('isJoined'),
            canGoBack: Global.get('canGoBack')
        });
        this.$el.html(html);
        this.renderAddToCalendar();
        this.renderTooltip();
        this.$el.toggleClass('hide', !isVisible);
        (!Global.get('me').isNew()) && this.model.reportView('session', Global.get('event').get('id'));
        return this;
    }

});

export default SessionPageView;


